module.exports = __webpack_public_path__ + "img/lan_tour_route_06.0fc8904c.jpg";